import { useEffect } from 'react';

function useScrollToTop(location) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
}

export default useScrollToTop;
